import { ChartTypes } from '@configs/graph';
import { IGraphConstants } from '@typings/graph';

export const graphTypes: ChartTypes[] = [ChartTypes.bar, ChartTypes.pie, ChartTypes.line, ChartTypes.area];

export const graphConstants: IGraphConstants = {
    LEGEND_DELIMITER: ' → ',
    EMPTY_GRAPH_DATA_VALUE: '✕',
};
